import { faCheck } from '@fortawesome/pro-regular-svg-icons'
import { Icon, Modal } from '@seiue/ui'
import { sortBy } from '@seiue/util'
import { FC, useState } from 'react'
import styled from 'styled-components'

import { Outline, courseApi } from 'packages/sdks-next/growp'
import { getTheme } from '@/utils/theme'

/**
 * 移动到章节弹窗内容
 *
 * @param param0 - 参数
 * @param param0.outlines - 课程章节
 * @param param0.hide - 关闭弹窗
 * @param param0.taskId - 任务id
 * @param param0.defaultOutlineId - 默认选中的章节id
 * @returns 组件
 */
export const MoveToChapterModalContent: FC<{
  outlines: Outline[]
  hide: () => void
  taskId: number
  defaultOutlineId?: number
}> = ({ outlines, hide, taskId, defaultOutlineId }) => {
  const [selectedOutlineId, setSelectedOutlineId] = useState<
    number | undefined
  >(defaultOutlineId)

  const theme = getTheme()

  const { api: moveCourseOutlineTask } = courseApi.useMoveCourseOutlineTask({
    reload: [courseApi.loadCourseActivityTask],
  })

  return (
    <>
      <Content>
        {sortBy(outlines, 'weight').map((outline) => {
          const isSelected = selectedOutlineId === outline.id
          return (
            <OutlineItem
              key={outline.id}
              onClick={() => {
                setSelectedOutlineId(outline.id)
              }}
              $isSelected={isSelected}
            >
              <OutlineName>{outline.name}</OutlineName>
              {isSelected ? (
                <Icon
                  icon={faCheck}
                  size={16}
                  color={theme.status.success.element}
                />
              ) : null}
            </OutlineItem>
          )
        })}
      </Content>
      <Modal.Footer
        onCancel={() => {
          hide()
        }}
        okButtonProps={{ disabled: !selectedOutlineId }}
        okText={'确定'}
        onOk={async () => {
          if (!selectedOutlineId || !defaultOutlineId) return
          if (defaultOutlineId === selectedOutlineId) {
            hide()
            return
          }
          await moveCourseOutlineTask({
            id: defaultOutlineId,
            taskId,
            payload: { outlineId: selectedOutlineId },
          })
          hide()
        }}
      />
    </>
  )
}

const Content = styled.div`
  padding: 20px 12px;
  overflow: auto;
  max-height: 300px;
`

const OutlineItem = styled.div<{ $isSelected: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  padding: 9px 8px;
  background: ${(p) => (p.$isSelected ? p.theme.brand._5 : '#ffffff')};
  cursor: pointer;
  &:hover {
    background-color: ${(p) => p.theme.brand._5};
  }
`

const OutlineName = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${(p) => p.theme.text._1};
`
